<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  {
                    title: 'Dashboard',
                    url: 'dashboard'
                  },
                  {
                    title: 'Link 1',
                    url: 'link-1'
                  },
                  {
                    title: 'Link 2',
                    disabled: true
                  },
                  {
                    title: 'Active',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
              <div class="frm-title">
                <div class="heading mt-3">
                  <h3
                    class="text-secondary"
                    style="font-size:20px;margin-bottom:0px"
                  >Funding Agency Information</h3>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead style="background:#06a6e0">
                    <tr class="text-white">
                      <th>Organization Name</th>
                      <th>Code</th>
                      <th>Person Name</th>
                      <th>Contact Number</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>UNDP Pakistan</td>
                      <td>0305</td>
                      <td>Usama Khan</td>
                      <td>0305 7892635</td>
                      <td>ali@gmail.com</td>
                    </tr>
                    <tr>
                      <td>UNHCR</td>
                      <td>03045</td>
                      <td>Ilyas Mukhtar Ali</td>
                      <td>0313 5795234</td>
                      <td>Ilyas32@gmail.com</td>
                    </tr>
                    <tr>
                      <td>UNICEF</td>
                      <td>8796</td>
                      <td>Gul Ahmed</td>
                      <td>0305 7892635</td>
                      <td>ahmed27@gmail.com</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  data: () => ({
    isSidebar: false
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
</style>
